import { ParentCallerUrlParam, IFrameClassName } from './constants';
import Log from '../utils/log';
import {
  getWindowCalledByParent, setWindowCalledByParent, setWindowCallerParams, getWindowCallerParams,
} from './windowData';
import { getUrlParams } from '../utils/navigation';

/**
 * Funzione che restituisce l'elenco dei parametri che vengono passati via querystring dal
 * chiamante. I paramentri saranno incrementali, quindi se viene cambiato l'url e
 * aggiunti parametri, verranno aggiunti a quelli già presenti
 */
const getCallerParams = () => {
  const urlParams = getUrlParams();
  // solo se presenti alcuni parametri vedo di salvarli e integrarli agli esistenti
  if (urlParams && Object.keys(urlParams).length > 0) {
    const callerParams = { ...getWindowCallerParams(), ...urlParams };
    setWindowCallerParams(callerParams);
    return callerParams;
  }
  return getWindowCallerParams();
};

let callerExtraParams = null;

/**
 * Funzione che ritorna la struttura di extraparams eventualmente passata dal partent chiamante
 */
const getCallerExtraParams = () => callerExtraParams;

/**
 * Metodo utilizzato per impostare gli extraparams eventualmente passati
 * @param {*} extraParams
 */
const setCallerExtraParams = (extraParams) => {
  callerExtraParams = extraParams;
};

/**
 * Funzione che restituisce l'id del parente che sta chiamando
 * l'appliazione, direttamente dai parametri querystring
 */
const getCallerParentIdFromParams = () => {
  const urlParams = getUrlParams();
  return urlParams[ParentCallerUrlParam];
};

/**
 * Funzione che restituisce l'id del parent che sta chiamando
 * l'applicazione dal valore in window o dai parametri
 */
const getCallerParentId = () => (getWindowCalledByParent() !== undefined ? getWindowCalledByParent() : getCallerParentIdFromParams()) || null;

/**
 * Metodo utilizzato dalle applicazioni per impostare una
 * variabile globale che informa se l'applicazione è stata
 * caricata da un parent
 */
const setCalledByParent = () => {
  // se viene invocato più volte questo metodo viene preservata la prima impostazione
  // visto che il parentId non dovrebbe cambiare nel tempo
  if (getWindowCalledByParent() !== undefined) {
    Log.warn('ParentId già impostato');
    return;
  }
  setWindowCalledByParent(getCallerParentIdFromParams() || false);
};

/**
 * Funzione che indica se l'applicazione è stata
 * caricata da un parent
 */
const isCalledByParent = () => !!getWindowCalledByParent() || false;

/**
 * Funzione che verifica l'esistenza di un iframe visualizzato
 */
const isPresentIFrame = () => document.getElementsByClassName(IFrameClassName).length > 0;

export {
  getCallerParams,
  getCallerExtraParams,
  setCallerExtraParams,
  setCalledByParent,
  isCalledByParent,
  getCallerParentId,
  isPresentIFrame,
};
